import type { QueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { getEligibilityV2 } from "@/sales-tools";
import type { EligibilityRequestV2 } from "../types";

const QUERY_KEY = "sales-eligibility-v2";

export const useEligibilityV2 = (request: EligibilityRequestV2, isEnabled = true) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: [QUERY_KEY, request.customerMdn, request.sessionId],
        queryFn: async () =>
            getEligibilityV2({
                ...request,
            }),
        staleTime: Infinity,
        gcTime: Infinity,
        retry: 1,
        enabled: isEnabled,
    });
    return { data, isLoading, isError };
};

export const clearEligibilityQueryCache = (queryClient: QueryClient, sessionId: string) => {
    queryClient.removeQueries({
        predicate: (query) => query.queryKey.includes(QUERY_KEY) && query.queryKey.includes(sessionId),
    });
};
